import { siteApiSlice } from "../../../../app/siteApiSlice";
import { MonthlyScoresFilteredByCourseViewModel } from "./MonthlyScoresFilteredByCourseViewModel";

export const courseProgressReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		courseProgressReport: build.query<
			MonthlyScoresFilteredByCourseViewModel,
			{
				courseId?: number;
				beginSchoolYear?: number;
				endSchoolYear?: number;
				today?: string;
			}
		>({
			query: (arg) => {
				const { courseId } = arg;
				return {
					url: `/course-progress-report`,
					params: { courseId },
				};
			},
			providesTags: ["WritingHistory", "CurrentCourse"],
		}),
	}),
});

export const { useCourseProgressReportQuery } = courseProgressReportApiSlice;
